export const PaginationTypes = {
  NONE: "none",
  INFINITE: "infinite",
  CAROUSEL: "carousel",
};

export const NewPaginationTypesMapper = {
  [PaginationTypes.NONE]: "none",
  [PaginationTypes.INFINITE]: "showmore",
  [PaginationTypes.CAROUSEL]: "prevnext",
};
